// Grid & Gauge — JavaScript minimal, sans dépendance, sans bibliothèque.
(function () {
  'use strict';

  // Galerie produit : une piste à défilement calé, que les vignettes et les flèches amènent
  // au bon endroit.
  //
  // LE DÉFILEMENT EST NATIF, ET CE CHOIX EST LE POINT. Avant, la vue principale était un seul
  // <img> dont les vignettes remplaçaient la source : on ne pouvait pas la balayer au doigt,
  // et il n'y avait rien à faire glisser au trackpad. Maintenant les photos sont toutes dans
  // la piste, et c'est le navigateur qui la fait défiler — le geste marche même si ce script
  // ne charge pas. Ce qui suit ne fait qu'y ajouter les vignettes, les flèches et le clavier.
  document.querySelectorAll('[data-galerie]').forEach(function (galerie) {
    var piste = galerie.querySelector('[data-galerie-piste]');
    if (!piste) { return; }
    var vues = Array.prototype.slice.call(galerie.querySelectorAll('[data-galerie-vue]'));
    var vignettes = Array.prototype.slice.call(galerie.querySelectorAll('[data-galerie-vignette]'));
    if (vues.length < 2) { return; }
    var prec = galerie.querySelector('[data-galerie-prec]');
    var suiv = galerie.querySelector('[data-galerie-suiv]');

    // Chaque vue occupe exactement la largeur de la piste : l'index se lit donc par une
    // division, sans mesurer chaque élément — et sans dépendre de l'élément de position,
    // que le conteneur relatif de la galerie déplacerait.
    function indexCourant() {
      if (!piste.clientWidth) { return 0; }
      return Math.round(piste.scrollLeft / piste.clientWidth);
    }

    function aller(i) {
      var n = Math.max(0, Math.min(vues.length - 1, i));
      piste.scrollLeft = n * piste.clientWidth;
    }

    function refleter() {
      var i = indexCourant();
      vignettes.forEach(function (b, j) {
        b.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      if (prec) { prec.hidden = i <= 0; }
      if (suiv) { suiv.hidden = i >= vues.length - 1; }
    }

    vignettes.forEach(function (bouton, i) {
      bouton.addEventListener('click', function () { aller(i); refleter(); });
    });
    if (prec) { prec.addEventListener('click', function () { aller(indexCourant() - 1); }); }
    if (suiv) { suiv.addEventListener('click', function () { aller(indexCourant() + 1); }); }

    // Au clavier : la piste est focalisable, les flèches la déplacent d'une vue. Sans cela,
    // une galerie défilable n'est utilisable qu'à la souris ou au doigt.
    piste.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); aller(indexCourant() + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); aller(indexCourant() - 1); }
    });

    // Le défilement au doigt ne passe par aucun de ces boutons : on suit la piste elle-même
    // pour que les vignettes disent toujours la vérité sur ce qui est affiché.
    var attente;
    piste.addEventListener('scroll', function () {
      clearTimeout(attente);
      attente = setTimeout(refleter, 90);
    }, { passive: true });
    window.addEventListener('resize', function () { aller(indexCourant()); });

    refleter();
  });

  // Le choix de langue s'applique à la sélection : un bouton de validation en plus
  // serait un clic de plus pour rien. Sans JavaScript, le bouton du noscript prend le relais.
  document.querySelectorAll('[data-langue-choix]').forEach(function (choix) {
    choix.addEventListener('change', function () {
      var formulaire = choix.closest('form');
      if (formulaire) { formulaire.submit(); }
    });
  });

  // Le choix de configuration met à jour le prix et le bouton sans recharger.
  document.querySelectorAll('[data-variantes]').forEach(function (groupe) {
    var formulaire = groupe.closest('form');
    if (!formulaire) { return; }
    groupe.addEventListener('change', function (evenement) {
      var choix = evenement.target;
      if (!choix.matches('input[type="radio"]')) { return; }
      var identifiant = choix.value;
      var champ = formulaire.querySelector('input[name="id"]');
      if (champ) { champ.value = identifiant; }
      document.querySelectorAll('[data-prix-variante="' + identifiant + '"]').forEach(function () {});
      var prix = choix.getAttribute('data-prix');
      document.querySelectorAll('[data-prix-affiche]').forEach(function (cible) {
        if (prix) { cible.textContent = prix; }
      });
      var disponible = choix.getAttribute('data-disponible') === 'true';
      formulaire.querySelectorAll('[data-ajouter]').forEach(function (bouton) {
        bouton.disabled = !disponible;
      });
    });
  });
})();


// Navigation. Trois gestes : signaler que le script est là, ouvrir le dépliant sur téléphone,
// et ne jamais laisser deux volets ouverts en même temps.
(function () {
  var racine = document.querySelector('[data-nav-racine]');
  if (!racine) { return; }
  racine.classList.add('nav--js');

  var bascule = racine.querySelector('[data-nav-bascule]');
  if (bascule) {
    bascule.addEventListener('click', function () {
      var ouvert = racine.classList.toggle('nav--ouvert');
      bascule.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    });
  }

  var volets = Array.prototype.slice.call(racine.querySelectorAll('[data-nav]'));
  volets.forEach(function (v) {
    v.addEventListener('toggle', function () {
      if (!v.open) { return; }
      volets.forEach(function (autre) { if (autre !== v) { autre.open = false; } });
    });
  });

  document.addEventListener('click', function (e) {
    if (racine.contains(e.target)) { return; }
    volets.forEach(function (v) { v.open = false; });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') { return; }
    volets.forEach(function (v) {
      if (!v.open) { return; }
      v.open = false;
      var s = v.querySelector('summary');
      if (s) { s.focus(); }
    });
  });
})();

/* ═══ Sélecteur pays + langue ═══
   Ouverture, fermeture à l'Échap et au clic extérieur, et surtout : la destination.

   Un formulaire n'a qu'un `return_to`. Chaque pays a pourtant la sienne, parce que changer
   de pays peut faire disparaître le produit regardé — le laser rotatif n'est pas vendable
   en Espagne. Le gabarit a calculé la bonne destination pour chaque pays ; on la recopie
   dans le champ au moment du clic. Sans JavaScript, `return_to` vaut la page en cours : le
   pire cas est une fiche sans bouton d'achat, jamais une page morte. */
(function () {
  function fermerTout() {
    document.querySelectorAll('[data-marche] .marche__panneau').forEach(function (p) { p.hidden = true; });
    document.querySelectorAll('[data-marche-ouvre]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  document.addEventListener('click', function (e) {
    var bouton = e.target.closest('[data-marche-ouvre]');
    if (bouton) {
      var panneau = document.getElementById(bouton.getAttribute('aria-controls'));
      var etaitOuvert = panneau && !panneau.hidden;
      fermerTout();
      if (panneau && !etaitOuvert) { panneau.hidden = false; bouton.setAttribute('aria-expanded', 'true'); }
      return;
    }
    var option = e.target.closest('.marche__opt[data-retour]');
    if (option) {
      var forme = option.closest('form');
      var champ = forme && forme.querySelector('[data-marche-retour]');
      if (champ) { champ.value = option.getAttribute('data-retour'); }
      return;
    }
    if (!e.target.closest('[data-marche]')) { fermerTout(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') { return; }
    var ouvert = document.querySelector('[data-marche-ouvre][aria-expanded="true"]');
    fermerTout();
    if (ouvert) { ouvert.focus(); }
  });
})();

/* La ligne qui explique pourquoi la fiche a disparu.
   Shopify n'expose aucun paramètre d'URL au Liquid : le serveur ne peut pas savoir qu'on
   arrive d'un changement de pays. Le navigateur, lui, voit l'adresse. La ligne est rendue
   masquée et traduite ; il ne fait que la montrer. Sans JavaScript, l'atterrissage reste
   correct — c'est le bon rayon, sans la phrase. */
(function () {
  if (!/[?&]retire=/.test(window.location.search)) { return; }
  var ligne = document.querySelector('[data-retire]');
  if (ligne) { ligne.hidden = false; }
})();
